import React, { useState, useEffect } from 'react'
import {
    CRow,
    CCol,
    CCard,
    CCardHeader,
    CCardBody,
    CBadge,
    CProgress,
    CProgressBar,
    CCardFooter,
    CPopover
} from '@coreui/react'
import { useQuery } from '@apollo/client';
import { useRouteMatch } from "react-router-dom";
import { GET_CANADIAN_PROVINCIAL_ELECTIONS } from '../../../../apollo/queries';
import history from '../../../../history'
import { activeMap } from '../../../../apollo/cache';
import ReactGA from 'react-ga';
import { flCapital, provinceNameToShort } from '../../../../helpers/Utils';
import { useSelector } from 'react-redux';

const CanadianProvincialElections = ({match}) => {

    var query, variables;

    let amatch = useRouteMatch("/political/canada/provincial/elections/:minor_jurisdiction");

    if (amatch !== null) {
        query = GET_CANADIAN_PROVINCIAL_ELECTIONS
        variables = { district: flCapital(match.params.minor_jurisdiction), minor_jurisdiction: provinceNameToShort(match.params.minor_jurisdiction) }
      } 

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    const { loading, error, data } = useQuery(query, {
        variables: variables
    });

    console.log(data);

    const handleClick = (map) => {
        ReactGA.event({
            category: "Provincial Election Map",
            action: "select",
            label: map.year,
          });        
        activeMap(map);
        history.push('/political/canada/provincial/election/'+match.params.minor_jurisdiction+'/'+map.year);
    }

    return (
        <CRow>
            { data ? data.getCanadianProvincialElections.map((elxn, i) => (                 
            <CCol key={i} xs="12" sm="6" md="4">                       
                <CCard onClick={() => handleClick(elxn)} style={{cursor:"pointer"}}>
                    <CCardHeader>
                    {elxn.year}
                    <div className="card-header-actions">
                    <CBadge color={
                        elxn.winner === "Progressive Conservative" ? "primary" 
                        : elxn.winner === "Liberal" ? "danger" 
                        : elxn.winner === "NDP" ? "warning" 
                        : elxn.winner === "United Conservative" ? "primary"
                        : "info"} className="float-right">{flCapital(elxn.government_type ? elxn.government_type : "")} government</CBadge>
                    </div>
                    </CCardHeader>
                    <CCardBody>
                    {elxn.year === '2022' && elxn.minor_jurisdiction === 'ON' ? 
                        <CProgress size="lg">
                            <CPopover content="Progressive Conservative: 83 seats">
                                <CProgressBar color="primary" value={83}/>
                            </CPopover>
                            <CPopover content="NDP: 31 seats">
                                <CProgressBar color="warning" value={31}/>
                            </CPopover>
                            <CPopover content="Liberal: 8 seats">
                                <CProgressBar color="danger" value={8}/>
                            </CPopover>
                            <CPopover content="Green: 1 seat">
                                <CProgressBar color="success" value={1}/>
                            </CPopover>
                            <CPopover content="Independent: 1 seat">
                                <CProgressBar color="secondary" value={1}/>
                            </CPopover>                            
                        </CProgress>
                    : <></> }
                    {elxn.year === '2018' && elxn.minor_jurisdiction === 'ON' ? 
                        <CProgress size="lg">
                            <CPopover content="Progressive Conservative: 76 seats">
                                <CProgressBar color="primary" value={76}/>
                            </CPopover>
                            <CPopover content="NDP: 40 seats">
                                <CProgressBar color="warning" value={70}/>
                            </CPopover>
                            <CPopover content="Liberal: 7 seats">
                                <CProgressBar color="danger" value={7}/>
                            </CPopover>
                            <CPopover content="Green: 1 seat">
                                <CProgressBar color="success" value={1}/>
                            </CPopover>
                        </CProgress>
                    : <></> }
                    {elxn.year === '2014' && elxn.minor_jurisdiction === 'ON' ? 
                        <CProgress size="lg">
                            <CPopover content="Liberal: 58 seats">
                                <CProgressBar color="danger" value={58}/>
                            </CPopover>
                            <CPopover content="Progressive Conservative: 28 seats">
                                <CProgressBar color="primary" value={28}/>
                            </CPopover>
                            <CPopover content="NDP: 21 seats">
                                <CProgressBar color="warning" value={21}/>
                            </CPopover>
                        </CProgress>
                    : <></> }
                    {elxn.year === '2011' && elxn.minor_jurisdiction === 'ON' ? 
                        <CProgress size="lg">
                            <CPopover content="Liberal: 53 seats">
                                <CProgressBar color="danger" value={53}/>
                            </CPopover>
                            <CPopover content="Progressive Conservative: 37 seats">
                                <CProgressBar color="primary" value={37}/>
                            </CPopover>
                            <CPopover content="NDP: 17 seats">
                                <CProgressBar color="warning" value={17}/>
                            </CPopover>
                        </CProgress>
                    : <></> }
                    {elxn.year === '2007' && elxn.minor_jurisdiction === 'ON' ? 
                        <CProgress size="lg">
                            <CPopover content="Liberal: 71 seats">
                                <CProgressBar color="danger" value={71}/>
                            </CPopover>
                            <CPopover content="Progressive Conservative: 26 seats">
                                <CProgressBar color="primary" value={26}/>
                            </CPopover>
                            <CPopover content="NDP: 10 seats">
                                <CProgressBar color="warning" value={10}/>
                            </CPopover>
                        </CProgress>
                    : <></> }
                    {elxn.year === '2003' && elxn.minor_jurisdiction === 'ON' ? 
                        <CProgress size="lg">
                            <CPopover content="Liberal: 72 seats">
                                <CProgressBar color="danger" value={72}/>
                            </CPopover>
                            <CPopover content="Progressive Conservative: 24 seats">
                                <CProgressBar color="primary" value={24}/>
                            </CPopover>
                            <CPopover content="NDP: 7 seats">
                                <CProgressBar color="warning" value={7}/>
                            </CPopover>
                        </CProgress>
                    : <></> }                                                                                
                    {elxn.year === '2019' && elxn.minor_jurisdiction === 'AB' ? 
                        <CProgress size="lg">
                            <CPopover content="United Conservative: 63 seats">
                                <CProgressBar color="primary" value={126}/>
                            </CPopover>
                            <CPopover content="NDP: 24 seats">
                                <CProgressBar color="warning" value={48}/>
                            </CPopover>
                        </CProgress>
                    : <></> }
                    {elxn.year === '2015' && elxn.minor_jurisdiction === 'AB' ? 
                        <CProgress size="lg">
                            <CPopover content="NDP: 54 seats">
                                <CProgressBar color="warning" value={108}/>
                            </CPopover>
                            <CPopover content="Wildrose: 21 seats">
                                <CProgressBar color="darkpurple" value={42}/>
                            </CPopover>
                            <CPopover content="Progressive Conservative: 9 seats">
                                <CProgressBar color="primary" value={18}/>
                            </CPopover>
                            <CPopover content="Liberal: 1 seat">
                                <CProgressBar color="danger" value={2}/>
                            </CPopover>
                            <CPopover content="Alberta Party: 1 seat">
                                <CProgressBar color="yellow" value={2}/>
                            </CPopover>
                        </CProgress>
                    : <></> }                                                                                                                        
                    {elxn.year === '2012' && elxn.minor_jurisdiction === 'AB' ? 
                        <CProgress size="lg">
                            <CPopover content="Progressive Conservative: 61 seats">
                                <CProgressBar color="primary" value={122}/>
                            </CPopover>
                            <CPopover content="Wildrose: 17 seats">
                                <CProgressBar style={{backgroundColor:'darkpurple'}} value={34}/>
                            </CPopover>
                            <CPopover content="Liberal: 5 seats">
                                <CProgressBar color="danger" value={10}/>
                            </CPopover>
                            <CPopover content="NDP: 4 seats">
                                <CProgressBar color="warning" value={8}/>
                            </CPopover>
                        </CProgress>
                    : <></> }
                    </CCardBody>
                </CCard>
            </CCol>
            )) : <></> }
        </CRow>
    )
  }
  
  export default CanadianProvincialElections;